import React, { memo } from "react";
import {
  View,
  TouchableWithoutFeedback,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import Text from "@components/AppText";
import AddToCart from "@assets/svg/AddToCart";
import RemoveFromCart from "@assets/svg/RemoveFromCart";
import { colors } from "@constants/theme";
import { useSelector, useDispatch } from "react-redux";
import { actions as authActions } from "@reducers/authReducer";
import color from "@constants/color";
import { normalize } from "./metrics";

const AddBtn = memo(
  ({
    width,
    onPressPlus = () => {},
    onPressMinus = () => {},
    count,
    isCartValueLoading = false,
    disabled = "false",
  }) => {
    const {
      user: { is_suspended = false, leader_state },
    } = useSelector(({ auth }) => auth);

    const dispatch = useDispatch();

    // CL suspension check
    // instead of checking suspenion for each add to cart call, we can just check here
    // and block the execution on props.onPress
    const isClSuspended = (event, callType = "plus") => {
      if (is_suspended || leader_state === "LEADER_SUSPENDED") {
        dispatch(authActions.showSuspensionModal(true));
        return;
      }
      if (callType === "plus") onPressPlus(event);
      if (callType === "minus") onPressMinus(event);
    };

    return (
      <View style={{ paddingBottom: 15 }}>
        <View style={[styles.container, { width: width || "auto" }]}>
          <TouchableWithoutFeedback onPress={(e) => isClSuspended(e, "minus")}>
            <View
              style={{
                // flexBasis: 45,
                flex: 1,
              }}
            >
              <View style={styles.removeCart}>
                <RemoveFromCart />
              </View>
            </View>
          </TouchableWithoutFeedback>
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              // paddingVertical: normalize(7),
            }}
          >
            {isCartValueLoading == true ? (
              <ActivityIndicator color={colors.primary} size="small" />
            ) : (
              <Text bold style={{ color: "black", fontSize: normalize(14) }}>
                {count}
              </Text>
            )}
          </View>
          <TouchableWithoutFeedback onPress={(e) => isClSuspended(e, "plus")}>
            <View
              style={{
                flex: 1,
                // flexBasis: 45,
                // backgroundColor:"yellow"
              }}
            >
              <View style={styles.addCart}>
                <AddToCart />
              </View>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </View>
    );
  },
);

export default AddBtn;

const styles = StyleSheet.create({
  container: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: color.primary,
    flexDirection: "row",
    alignItems: "stretch",
    height: normalize(30),
    overflow: "hidden",
    marginRight: 1,
  },
  removeCart: {
    width: normalize(30),
    backgroundColor: color.primary,
    alignItems: "center",
    justifyContent: "center",
    marginRight: "auto",
    height: normalize(30),
  },
  addCart: {
    width: normalize(30),
    backgroundColor: color.primary,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    height: normalize(30),
  },
});
